import React, { useCallback, useMemo } from 'react';
import { SidekickCategories } from '../../../../static/categories';

import { ReactComponent as DeclineIcon } from './../../../projectSubCategory/decline-icon.svg';
import { ReactComponent as UploadPortfolioIcon } from './../../../postCreationForm/firstPage/upload-portfolio-icon.svg';
import { ReactComponent as BriefIcon } from './../../../postCreationForm/firstPage/brief-icon.svg';
import { AcceptIcon } from './../../../projectSubCategory/accept-icon';
import classNames from 'classnames';
import { postsPages } from '../../../projectSubCategory/SubCategory';
import { answerStateTypes } from '../PostFooter';

const responseTypes = {
    accept: 'accept',
    decline: 'decline',
};

const InvitedPostLabel = ({
    category,
    subCategoryTitle,
    subCategories,
    handleResponse,
    responseEmails,
    isProjectPostPage,
    handleShowBrief,
    handleUploadPortfolio,
    answerState,
    page,
    briefLink,
}) => {
    const color = useMemo(() => SidekickCategories[category.toLowerCase()]?.color || '#30CC9D', [
        category,
    ]);

    const handleResponseClick = useCallback(
        e => {
            e.stopPropagation();
            handleResponse(e);
        },
        [handleResponse]
    );

    const uploadPortfolioClass = classNames({
        'upload-portfolio-btn-wrap': true,
        'is-already-uploaded': answerState === answerStateTypes.full_accepted,
        'is-project-post-page': isProjectPostPage,
    });

    const briefLinkClass = classNames({
        'brief-link-wrap': true,
        // 'show-brief-btn-wrap': true,
        'is-project-post-page': isProjectPostPage,
    });

    return (
        <>
            {page === postsPages.invited ? (
                subCategoryTitle === subCategories.inProgress ? (
                    <div className="make-hired">
                        <span className="make-hired-text">You&apos;re Hired</span>
                        <AcceptIcon color={color} />
                    </div>
                ) : answerState === answerStateTypes.not_answered ? (
                    <div className="make-hired">
                        <span className="make-hired-text">Available?</span>
                        <div className="make-icons-wrap">
                            <div
                                data-type={responseTypes.decline}
                                className="available-icon-wrap"
                                onClick={handleResponseClick}
                            >
                                <DeclineIcon />
                            </div>
                            <div
                                data-type={responseTypes.accept}
                                className="available-icon-wrap"
                                onClick={handleResponseClick}
                            >
                                <AcceptIcon color={color} />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="responsed-label">
                        {answerState === answerStateTypes.declined ? (
                            <>
                                <span className="responsed-label-text">You rejected</span>
                                <div className="icon-wrap">
                                    <DeclineIcon />
                                </div>
                            </>
                        ) : (
                            <>
                                {!!briefLink.length && (
                                    <div className={briefLinkClass} onClick={handleShowBrief}>
                                        <BriefIcon className="brief-icon-post" />
                                        {/* {isProjectPostPage && ( */}
                                        <span className="brief-title-post">Brief</span>
                                        {/* )} */}
                                    </div>
                                )}
                                <div
                                    className={uploadPortfolioClass}
                                    onClick={handleUploadPortfolio}
                                >
                                    <UploadPortfolioIcon className="upload-portfolio-icon-post" />
                                    {/* {isProjectPostPage && ( */}
                                    <span className="upload-portfolio-title-post">
                                        {answerState === answerStateTypes.partial_accepted
                                            ? 'Submit'
                                            : 'Submitted'}
                                    </span>
                                    {/* )} */}
                                </div>
                            </>
                        )}
                    </div>
                )
            ) : null}
        </>
    );
};

export default InvitedPostLabel;
